module.exports = __webpack_public_path__ + "img/logo.529e6ad7.png";